import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import { Skeleton } from '@mui/material';
export default _styled(Skeleton, {
  target: "exkdq690"
})(process.env.NODE_ENV === "production" ? {
  name: "8il71w",
  styles: "&.MuiSkeleton-rectangular{border-radius:8px;}"
} : {
  name: "8il71w",
  styles: "&.MuiSkeleton-rectangular{border-radius:8px;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NrZWxldG9uL3N0eWxlcy9Ta2VsZXRvbkJsb2NrU3R5bGVkLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHK0IiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2tlbGV0b24vc3R5bGVzL1NrZWxldG9uQmxvY2tTdHlsZWQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgU2tlbGV0b24gfSBmcm9tICdAbXVpL21hdGVyaWFsJztcblxuZXhwb3J0IGRlZmF1bHQgc3R5bGVkKFNrZWxldG9uKWBcbiAgJi5NdWlTa2VsZXRvbi1yZWN0YW5ndWxhciB7XG4gICAgYm9yZGVyLXJhZGl1czogOHB4O1xuICB9XG5gOzsiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
;